import { render, staticRenderFns } from "./Declaration.vue?vue&type=template&id=7847cdd4&scoped=true"
import script from "./Declaration.vue?vue&type=script&lang=js"
export * from "./Declaration.vue?vue&type=script&lang=js"
import style0 from "./Declaration.vue?vue&type=style&index=0&id=7847cdd4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7847cdd4",
  null
  
)

export default component.exports